import '../styles/Clients.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt, FaFileContract } from 'react-icons/fa';
import { API } from '../config/api';
import MapCompteurSelector from '../components/MapCompteurSelector';

export default function Clients() {
  const [showModal, setShowModal] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [showCheckContractModal, setShowCheckContractModal] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [selectedClientForContract, setSelectedClientForContract] = useState(null);
  const [clientContracts, setClientContracts] = useState([]);
  const [searchType, setSearchType] = useState('nom');
  const [searchValue, setSearchValue] = useState('');
  const [statutFilter, setStatutFilter] = useState('');
  const [clients, setClients] = useState([]);
  const [secteurs, setSecteurs] = useState([]);
  const [clientsWithContracts, setClientsWithContracts] = useState(new Set());

  const [form, setForm] = useState({
    nom: '', prenom: '', adresse: '', ville: '',
    tel: '', email: '', idS: '', statut: 'actif'
  });

  const generateQr = () => {
    const d = new Date();
    return `QR-${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}-${Math.floor(1000 + Math.random() * 9000)}`;
  };

  const [contractForm, setContractForm] = useState({
    codeQr: generateQr(),
    dateDebut: '',
    dateFin: '',
    numSerieCompteur: '',
    marqueCompteur: '',
    idClient: '',
    idS: '',
    posX: '',
    posY: '',
    hasExistingContract: false,
    lastPaymentPeriod: '',
    lastConsumptionReading: ''
  });

  const token = localStorage.getItem('token');

  const fetchClients = async () => {
    try {
      const res = await axios.get(API+'/api/clients', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClients(res.data);
    } catch (err) {
      console.error('Erreur chargement clients :', err);
    }
  };

  const fetchClientsWithContracts = async () => {
    try {
      const res = await axios.get(API+'/api/contracts', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const contracts = res.data;
      const clientIdsWithContracts = new Set(contracts.map(contract => contract.idclient));
      setClientsWithContracts(clientIdsWithContracts);
    } catch (err) {
      console.error('Erreur chargement contrats :', err);
    }
  };

  const fetchSecteurs = async () => {
    try {
      const res = await axios.get(API+'/api/secteurs', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSecteurs(res.data);
    } catch (err) {
      console.error('Erreur chargement secteurs :', err);
    }
  };

  useEffect(() => {
    fetchClients();
    fetchSecteurs();
    fetchClientsWithContracts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const openModal = (client = null) => {
    setEditingClient(client);
    setForm(client || {
      nom: '', prenom: '', adresse: '', ville: '',
      tel: '', email: '', statut: 'actif'
    });
    setShowModal(true);
  };
  

  const handleDelete = async (id) => {
    // Vérifier si le client a des contrats
    if (clientsWithContracts.has(id)) {
      alert("❌ Impossible de supprimer ce client car il a au moins un contrat associé.");
      return;
    }

    if (window.confirm("Supprimer ce client ?")) {
      try {
        await axios.delete(API+`/api/clients/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchClients();
      } catch (err) {
        console.error('❌ Erreur suppression client:', err);
        alert("Erreur lors de la suppression du client.");
      }
    } else {
      console.log("Suppression annulée");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingClient) {
        await axios.put(API+`/api/clients/${editingClient.idclient}`, form, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(API+'/api/clients', form, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      setShowModal(false);
      setEditingClient(null);
      fetchClients();
    } catch (err) {
      alert("Erreur lors de l’enregistrement.");
      console.error(err);
    }
  };
  
  const checkClientContracts = async (client) => {
    try {
      setSelectedClientForContract(client);
      // Fetch contracts for this specific client
      const res = await axios.get(API+`/api/contracts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const clientContracts = res.data.filter(contract => contract.idclient === client.idclient);
      setClientContracts(clientContracts);
      setShowCheckContractModal(true);
    } catch (err) {
      console.error('Erreur lors de la vérification des contrats:', err);
      alert('Erreur lors de la vérification des contrats du client');
    }
  };

  const openContractModal = (client) => {
    setSelectedClientForContract(client);
    setContractForm({
      codeQr: generateQr(),
      dateDebut: '',
      dateFin: '',
      numSerieCompteur: '',
      marqueCompteur: '',
      idClient: client.idclient,
      idS: '',
      posX: '',
      posY: '',
      hasExistingContract: false,
      lastPaymentPeriod: '',
      lastConsumptionReading: ''
    });
    setShowCheckContractModal(false);
    setShowContractModal(true);
  };

  const handleContractSubmit = async (e) => {
    e.preventDefault();
    
    // Validation for existing contract
    if (contractForm.hasExistingContract) {
      if (!contractForm.lastPaymentPeriod) {
        alert('⚠️ Veuillez entrer la période du dernier paiement');
        return;
      }
      if (!contractForm.lastConsumptionReading || contractForm.lastConsumptionReading <= 0) {
        alert('⚠️ Veuillez entrer une lecture de compteur valide');
        return;
      }
    }
    
    try {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      const contractData = {
        ...contractForm,
        dateFin: contractForm.dateFin || null,
        idTech: user.idtech || null
      };
      
      const contractResponse = await axios.post(API + '/api/contracts', 
        { ...contractData, dateContract: new Date().toISOString() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // If this is a new contract with existing paper contract data
      if (contractForm.hasExistingContract && contractForm.lastPaymentPeriod && contractForm.lastConsumptionReading) {
        try {
          // Get the contract ID from response - handle nested structure
          let contractId;
          
          if (contractResponse.data?.contract?.idcontract) {
            // Nested structure: { contract: { idcontract: 16 } }
            contractId = contractResponse.data.contract.idcontract;
          } else if (contractResponse.data?.idcontract) {
            // Direct structure: { idcontract: 16 }
            contractId = contractResponse.data.idcontract;
          } else if (contractResponse.data?.id) {
            // Alternative: { id: 16 }
            contractId = contractResponse.data.id;
          } else if (contractResponse.data?.insertId) {
            // MySQL insert result: { insertId: 16 }
            contractId = contractResponse.data.insertId;
          } else {
            // Last resort: maybe the response is just the ID
            contractId = contractResponse.data;
          }
          
          console.log('Contract response:', contractResponse.data);
          console.log('Extracted contract ID:', contractId);
          
          if (!contractId) {
            throw new Error('Contract ID not found in response');
          }
          
          // Create initial consumption record with correct field names
          const consumptionData = {
            idCont: contractId,                                    // Capitalized C (as expected by API)
            periode: contractForm.lastPaymentPeriod,
            consommationPre: 0,                                   // Capitalized P (as expected by API)
            consommationActuelle: parseInt(contractForm.lastConsumptionReading), // Capitalized A (as expected by API)
            jours: 30,
            idTech: user.idtech || null,                          // Capitalized T (as expected by API)
            status: 'fait'
          };
          
          console.log('Creating consumption with data:', consumptionData);
          
          await axios.post(API + '/api/consommations', consumptionData, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          alert(`✅ Contrat créé avec succès pour ${selectedClientForContract.nom} ${selectedClientForContract.prenom}!
📊 Consommation initiale enregistrée:
   • Période: ${contractForm.lastPaymentPeriod}
   • Lecture: ${contractForm.lastConsumptionReading} m³
   
🚀 Le suivi digital peut maintenant commencer à partir de ${contractForm.lastPaymentPeriod}`);
        } catch (consError) {
          console.error('Erreur création consommation initiale:', consError);
          alert('✅ Contrat créé avec succès!\n⚠️ Erreur lors de la création de la consommation initiale. Vous pouvez l\'ajouter manuellement.');
        }
      } else {
        alert(`✅ Contrat créé avec succès pour ${selectedClientForContract.nom} ${selectedClientForContract.prenom}!\n📊 Une consommation initiale a été créée automatiquement.`);
      }
      
      setShowContractModal(false);
      setSelectedClientForContract(null);
      fetchClientsWithContracts();
    } catch (err) {
      console.error('Erreur enregistrement contrat:', err);
      alert('❌ Erreur lors de l\'enregistrement du contrat');
    }
  };

  const handleSecteurChange = (e) => {
    const idS = e.target.value;
    setContractForm(f => ({ ...f, idS }));
    const secteur = secteurs.find(s => s.ids === parseInt(idS));
    if (secteur) {
      setContractForm(f => ({
        ...f,
        posX: secteur.longitude,
        posY: secteur.latitude
      }));
    }
  };
  const filteredClients = clients.filter(client => {
    const field = client[searchType]?.toLowerCase() || '';
    const matchSearch = field.includes(searchValue.toLowerCase());
    const matchStatut = statutFilter ? client.statut === statutFilter : true;
    return matchSearch && matchStatut;
  });

  return (
    <div className="clients-container">
  <h1 className="clients-title">Gestion des Clients</h1>

  <div className="clients-toolbar">
    <div className="clients-filters">
      <select value={searchType} onChange={e => setSearchType(e.target.value)}>
        <option value="nom">Nom</option>
        <option value="prenom">Prénom</option>
        <option value="ville">Ville</option>
        <option value="tel">Téléphone</option>
      </select>
      <input
        type="text"
        placeholder="Rechercher..."
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
      />
      <select value={statutFilter} onChange={e => setStatutFilter(e.target.value)}>
        <option value="">Tous les statuts</option>
        <option value="actif">Actif</option>
        <option value="inactif">Inactif</option>
      </select>
    </div>
    <button className=" clients-btn-primary" onClick={() => openModal(null)}>+ Ajouter Client</button>
  </div>

  <table className="clients-table">
    <thead>
      <tr>
        <th>Nom</th>
        <th>Prénom</th>
        <th>Ville</th>
        <th>Téléphone</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {filteredClients.map((c, i) => (
        <tr key={i}>
          <td>{c.nom}</td>
          <td>{c.prenom}</td>
          <td>{c.ville}</td>
          <td>{c.tel}</td>
          <td>
            <span className={`status-badge ${c.statut === "actif" ? "active" : "inactive"}`}>
              {c.statut}
            </span>
          </td>
          <td>
            <button className="clients-btn-edit" onClick={() => openModal(c)}><FaEdit /></button>
            <button 
              className="clients-btn-edit" 
              onClick={() => checkClientContracts(c)}
              title="Vérifier et ajouter un contrat"
              style={{ marginLeft: '5px' }}
            >
              <FaFileContract />
            </button>
            <button 
              className={`clients-btn-delete ${clientsWithContracts.has(c.idclient) ? 'disabled' : ''}`}
              onClick={() => handleDelete(c.idclient)}
              disabled={clientsWithContracts.has(c.idclient)}
              title={clientsWithContracts.has(c.idclient) ? 'Impossible de supprimer : ce client a des contrats' : 'Supprimer ce client'}
              style={{
                opacity: clientsWithContracts.has(c.idclient) ? 0.5 : 1,
                cursor: clientsWithContracts.has(c.idclient) ? 'not-allowed' : 'pointer',
                backgroundColor: clientsWithContracts.has(c.idclient) ? '#ccc' : ''
              }}
            >
              <FaTrashAlt />
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {showModal && (
    <div className="clients-modal-backdrop">
      <div className="clients-modal-box">
        <h2 className="clients-modal-title">
          {editingClient ? 'Modifier le Client' : 'Ajouter un Client'}
        </h2>
        <form className="clients-modal-form" onSubmit={handleSubmit}>
         
          <input name="nom" placeholder="Nom" value={form.nom} onChange={handleChange} required />
          <input name="prenom" placeholder="Prénom" value={form.prenom} onChange={handleChange} required />
          <input name="adresse" placeholder="Adresse" value={form.adresse} onChange={handleChange} required />
          <input name="ville" placeholder="Ville" value={form.ville} onChange={handleChange} required />
          <input name="tel" placeholder="Téléphone" value={form.tel} onChange={handleChange} required />
          <input name="email" placeholder="Email (optionnel)" value={form.email} onChange={handleChange} />
          <select name="statut" value={form.statut} onChange={handleChange}>
            <option value="actif">Actif</option>
            <option value="inactif">Inactif</option>
          </select>
          <div className="modal-actions">
            <button className="clients-btn-save" type="submit">Enregistrer</button>
            <button className="clients-btn-cancel" type="button" onClick={() => setShowModal(false)}>Annuler</button>
          </div>
        </form>
      </div>
    </div>
  )}

  {showCheckContractModal && selectedClientForContract && (
    <div className="clients-modal-backdrop">
      <div className="clients-modal-box" style={{ maxWidth: '600px' }}>
        <h2 className="clients-modal-title">
          📋 Vérification des Contrats - {selectedClientForContract.nom} {selectedClientForContract.prenom}
        </h2>
        <div style={{ padding: '20px', fontSize: '15px' }}>
          {clientContracts.length > 0 ? (
            <div>
              <div style={{ 
                padding: '15px', 
                backgroundColor: '#fff3cd', 
                borderRadius: '8px', 
                marginBottom: '20px',
                border: '1px solid #ffc107'
              }}>
                <strong style={{ fontSize: '16px' }}>⚠️ Ce client a déjà {clientContracts.length} contrat(s) actif(s)</strong>
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <h4 style={{ marginBottom: '10px' }}>Contrats existants :</h4>
                {clientContracts.map((contract, index) => (
                  <div 
                    key={contract.idcontract} 
                    style={{ 
                      padding: '12px', 
                      backgroundColor: '#f8f9fa', 
                      borderRadius: '6px', 
                      marginBottom: '10px',
                      border: '1px solid #dee2e6'
                    }}
                  >
                    <div><strong>Code QR:</strong> {contract.codeqr}</div>
                    <div><strong>Date début:</strong> {new Date(contract.datedebut).toLocaleDateString('fr-FR')}</div>
                    <div><strong>Marque:</strong> {contract.marquecompteur || 'N/A'}</div>
                    {contract.datefin && (
                      <div><strong>Date fin:</strong> {new Date(contract.datefin).toLocaleDateString('fr-FR')}</div>
                    )}
                  </div>
                ))}
              </div>
              
             
            </div>
          ) : (
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#d4edda', 
              borderRadius: '8px', 
              marginBottom: '20px',
              border: '1px solid #28a745',
              textAlign: 'center'
            }}>
              <strong style={{ fontSize: '16px', color: '#155724' }}>
                ✅ Ce client n'a pas de contrat existant
              </strong>
              <p style={{ marginTop: '10px', color: '#155724' }}>
                Vous pouvez créer un nouveau contrat pour ce client.
              </p>
            </div>
          )}
          
          <div className="modal-actions" style={{ marginTop: '20px' }}>
            <button 
              className="clients-btn-save" 
              type="button"
              onClick={() => openContractModal(selectedClientForContract)}
            >
              ➕ Créer un Nouveau Contrat
            </button>
            <button 
              className="clients-btn-cancel" 
              type="button" 
              onClick={() => {
                setShowCheckContractModal(false);
                setSelectedClientForContract(null);
                setClientContracts([]);
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  )}

  {showContractModal && selectedClientForContract && (
    <div className="clients-modal-backdrop">
      <div className="clients-modal-box" style={{ maxWidth: '800px', maxHeight: '90vh', overflow: 'auto' }}>
        <h2 className="clients-modal-title">
          Nouveau Contrat pour {selectedClientForContract.nom} {selectedClientForContract.prenom}
        </h2>
        <form onSubmit={handleContractSubmit} style={{ display: 'grid', gap: '15px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Code QR</label>
              <input 
                value={contractForm.codeQr} 
                readOnly 
                style={{ width: '100%', padding: '8px', backgroundColor: '#f5f5f5' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Marque compteur *</label>
              <input 
                value={contractForm.marqueCompteur} 
                onChange={e => setContractForm({ ...contractForm, marqueCompteur: e.target.value })} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Secteur *</label>
            <select 
              value={contractForm.idS} 
              onChange={handleSecteurChange} 
              required
              style={{ width: '100%', padding: '8px' }}
            >
              <option value="">Sélectionner un secteur</option>
              {secteurs.map(s => (
                <option key={s.ids} value={s.ids}>{s.nom}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Date de début *</label>
              <input 
                type="date" 
                value={contractForm.dateDebut} 
                onChange={e => setContractForm({ ...contractForm, dateDebut: e.target.value })} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Date de fin</label>
              <input 
                type="date" 
                value={contractForm.dateFin} 
                onChange={e => setContractForm({ ...contractForm, dateFin: e.target.value })} 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <input
                type="checkbox"
                id="hasExistingContract"
                checked={contractForm.hasExistingContract}
                onChange={e => setContractForm({ ...contractForm, hasExistingContract: e.target.checked })}
                style={{ marginRight: '10px' }}
              />
              <label htmlFor="hasExistingContract" style={{ fontWeight: 'bold' }}>
                📄 Client avec contrat papier existant
              </label>
            </div>
            
            {contractForm.hasExistingContract && (
              <div style={{ display: 'grid', gap: '10px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Période du dernier paiement *</label>
                  <input
                    type="month"
                    value={contractForm.lastPaymentPeriod}
                    onChange={e => setContractForm({ ...contractForm, lastPaymentPeriod: e.target.value })}
                    required={contractForm.hasExistingContract}
                    max={new Date().toISOString().slice(0, 7)}
                    style={{ width: '100%', padding: '8px' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px' }}>Dernière lecture du compteur (m³) *</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={contractForm.lastConsumptionReading}
                    onChange={e => setContractForm({ ...contractForm, lastConsumptionReading: e.target.value })}
                    required={contractForm.hasExistingContract}
                    placeholder="Ex: 1250"
                    style={{ width: '100%', padding: '8px' }}
                  />
                </div>
              </div>
            )}
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Position du compteur *</label>
            <MapCompteurSelector
              secteurId={contractForm.idS}
              position={
                contractForm.posX && contractForm.posY
                  ? { lat: parseFloat(contractForm.posY), lng: parseFloat(contractForm.posX) }
                  : null
              }
              onSelect={({ lat, lng }) =>
                setContractForm(f => ({ ...f, posX: lng.toFixed(6), posY: lat.toFixed(6) }))
              }
            />
          </div>

          <div className="modal-actions">
            <button className="clients-btn-save" type="submit">Créer le Contrat</button>
            <button 
              className="clients-btn-cancel" 
              type="button" 
              onClick={() => {
                setShowContractModal(false);
                setSelectedClientForContract(null);
              }}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  )}

  <footer className="page-footer">
    <p>© 2025 Abar. Powered by <strong>Jysser Connect</strong></p>
  </footer>
</div>

  );
}

